/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiServicesDataTransferObjectsReplyServiceHouseholdPersonAnswerDto } from './WebApiServicesDataTransferObjectsReplyServiceHouseholdPersonAnswerDto';
import {
    WebApiServicesDataTransferObjectsReplyServiceHouseholdPersonAnswerDtoFromJSON,
    WebApiServicesDataTransferObjectsReplyServiceHouseholdPersonAnswerDtoFromJSONTyped,
    WebApiServicesDataTransferObjectsReplyServiceHouseholdPersonAnswerDtoToJSON,
} from './WebApiServicesDataTransferObjectsReplyServiceHouseholdPersonAnswerDto';

/**
 * A primary member answers an event for the household through a personal invite.
 * @export
 * @interface WebApiServicesDataTransferObjectsReplyServiceSaveHouseholdReplyDto
 */
export interface WebApiServicesDataTransferObjectsReplyServiceSaveHouseholdReplyDto {
    /**
     * The id of the event.
     * @type {number}
     * @memberof WebApiServicesDataTransferObjectsReplyServiceSaveHouseholdReplyDto
     */
    eventId?: number;
    /**
     * The unique id of the personal invite.
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsReplyServiceSaveHouseholdReplyDto
     */
    inviteId?: string | null;
    /**
     * Message to the organizer.
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsReplyServiceSaveHouseholdReplyDto
     */
    answer?: string | null;
    /**
     * The people of the household that are signed up, each with own answers.
     * @type {Array<WebApiServicesDataTransferObjectsReplyServiceHouseholdPersonAnswerDto>}
     * @memberof WebApiServicesDataTransferObjectsReplyServiceSaveHouseholdReplyDto
     */
    people?: Array<WebApiServicesDataTransferObjectsReplyServiceHouseholdPersonAnswerDto> | null;
}

/**
 * Check if a given object implements the WebApiServicesDataTransferObjectsReplyServiceSaveHouseholdReplyDto interface.
 */
export function instanceOfWebApiServicesDataTransferObjectsReplyServiceSaveHouseholdReplyDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiServicesDataTransferObjectsReplyServiceSaveHouseholdReplyDtoFromJSON(json: any): WebApiServicesDataTransferObjectsReplyServiceSaveHouseholdReplyDto {
    return WebApiServicesDataTransferObjectsReplyServiceSaveHouseholdReplyDtoFromJSONTyped(json, false);
}

export function WebApiServicesDataTransferObjectsReplyServiceSaveHouseholdReplyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiServicesDataTransferObjectsReplyServiceSaveHouseholdReplyDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'eventId': !exists(json, 'eventId') ? undefined : json['eventId'],
        'inviteId': !exists(json, 'inviteId') ? undefined : json['inviteId'],
        'answer': !exists(json, 'answer') ? undefined : json['answer'],
        'people': !exists(json, 'people') ? undefined : (json['people'] === null ? null : (json['people'] as Array<any>).map(WebApiServicesDataTransferObjectsReplyServiceHouseholdPersonAnswerDtoFromJSON)),
    };
}

export function WebApiServicesDataTransferObjectsReplyServiceSaveHouseholdReplyDtoToJSON(value?: WebApiServicesDataTransferObjectsReplyServiceSaveHouseholdReplyDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'eventId': value.eventId,
        'inviteId': value.inviteId,
        'answer': value.answer,
        'people': value.people === undefined ? undefined : (value.people === null ? null : (value.people as Array<any>).map(WebApiServicesDataTransferObjectsReplyServiceHouseholdPersonAnswerDtoToJSON)),
    };
}

